import store from '../../../global-state/redux';
import { MODULE_NAME, NOTIFICATION_HUB_PATH } from './constants';
import { selectIsActive, selectSettings } from '../../hooks';

const { getState } = store;

// Activation is owned by this module, independent of the single-login SignalR
// module — enabling notifications does not enable the remote-logout flow.
export const getIsActive = () => selectIsActive(MODULE_NAME)(getState());

// Connect base URL for the notification hub. Owned by this module so the
// notification feature is self-contained.
export const signalRUrl = () => selectSettings(MODULE_NAME)(getState())?.signalRUrl;

// Full URL of the notification hub, derived from this module's `signalRUrl`.
export const notificationHubUrl = () => {
  const base = signalRUrl();
  return base ? `${base}${NOTIFICATION_HUB_PATH}` : null;
};

// Group name format used by the notification hub:
//  - user-specific:  `${instance}_Event_${eventShort}_${userId}`
//  - broadcast:      `${instance}_Event_${eventShort}_CustomNotification`
export const buildUserGroup = ({ instance, eventShort, userId }) => `${instance}_Event_${eventShort}_${userId}`;
export const buildBroadcastGroup = ({ instance, eventShort }) => `${instance}_Event_${eventShort}_CustomNotification`;

// Default toast duration (seconds) configured in the admin module.
export const defaultDurationSeconds = () =>
  Number(selectSettings(MODULE_NAME)(getState())?.defaultDurationSeconds ?? 30);
